import React, { useEffect, useState } from 'react';
import GridInputs from '../../components/common/inputs/GridInputs';
import axios from 'axios';
import { SubmitButton } from '../../components/common/button/CustomButtons';
import useConfirm from '../../components/common/useConfirm';
import { SelectChangeEvent } from '@mui/material';
import moment from 'moment';
import TimeGridMui from '../../components/common/dateCustom/TimeGridMui';

const Create = ({
  id,
  setIsModal,
  setId,
}: {
  id?: string | null;
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>;
  setId: any;
}) => {
  const [data, setData] = useState<any>({});
  const [_, setRender] = useState(false);
  const [DialogSubmit, confirmSubmit] = useConfirm(
    `${id ? 'Update Shift' : 'Create Shift'}`,
    `Are you sure you want to ${id ? 'update' : 'save'} this?`,
  );

  useEffect(() => {
    if (id) {
      axios
        .get(`/api/daySchedulingRoute/${id}`)
        .then((res) => {
          setData(res.data);
        })
        .catch((err) => console.log(err));
    }
  }, [id]);

  function handleChange(
    e: React.ChangeEvent<HTMLInputElement> | SelectChangeEvent<unknown>,
  ) {
    setData((prev: any) => ({ ...prev, [e.target.name]: e.target.value }));
  }

  const handleSumbit = async () => {
    const ans = await confirmSubmit();
    if (!ans) return;
    if (id) {
      await axios
        .put(`/api/daySchedulingRoute/${id}`, data)
        .then((res) => {
          setIsModal(false);
          setId(null);
        })
        .catch((err) => {
          alert('unable to create duplicate day');
          console.log(err);
        });
    } else {
      await axios
        .post('/api/daySchedulingRoute', data)
        .then((res) => {
          setIsModal(false);
          setId(null);
        })
        .catch((err) => {
          alert('unable to create duplicate day');
          console.log(err);
        });
    }
  };

  return (
    <>
      <GridInputs
        id={'day'}
        name={'day'}
        html_for={'day'}
        label_name={'DAY:'}
        input_type={'text'}
        focusType={'onblur'}
        value={data?.day}
        onChange={handleChange}
      />
      <div
        className="btn_save"
        style={{
          position: 'absolute',
          right: '140px',
          top: '-0.6px',
        }}
      >
        <SubmitButton
          label={`${id ? 'update' : 'submit'}`}
          type="button"
          onClick={handleSumbit}
        />
      </div>
      <DialogSubmit />
    </>
  );
};

export default Create;
